import { getUser } from "./getUser";
import { refreshAccessToken } from "./refreshToken";
import sessionInterceptor from "./session.interceptor";

async function apiWithRetry(
  url: string,
  options?: RequestInit,
  isRetry = false
): Promise<Response> {
  const userToken = getUser().token;
  let headers: RequestInit["headers"] = {};

  if (options?.headers) {
    headers = { ...options.headers } as Record<string, string>;
  }
  if (userToken) {
    (headers as Record<string, string>)["authorization"] = `Bearer ${userToken}`;
  }

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401 && !isRetry) {
    const newToken = await refreshAccessToken();
    if (newToken) {
      return apiWithRetry(url, options, true);
    }
  }

  if (response.status === 401) {
    await sessionInterceptor(response);
  }

  return response;
}

export default async function api(url: string, options?: RequestInit) {
  return apiWithRetry(url, options);
}
